import { createSlice } from "@reduxjs/toolkit";
import { AIBuilderState } from "./types";
import * as thunks from "./thunks";

const initialState: AIBuilderState = {
  AIBuilderList: [],
  AIBuilderDetails: {},
  meta: null,
  links: null,
  isLastPage: true,
};

const slice = createSlice({
  name: "AiBulderState",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(thunks.getAiBuilderNextPageThunk.rejected, () => {
      console.error("failed at getAiBuilderThunk");
    });
    builder.addCase(
      thunks.getAiBuilderNextPageThunk.fulfilled,
      (state, { payload }) => {
        const data = payload?.originalData?.data;

        if (data?.length > 0) {
          state.AIBuilderList.push(...data);
        }

        const meta = payload?.originalData?.meta;
        state.meta = meta || null;
        state.isLastPage =
          payload?.originalData?.links.next === null ||
          data.length < Number(meta?.per_page);
      }
    );
    builder.addCase(
      thunks.getAiBuilderThunk.pending,
      (state, { payload }) => {}
    );
    builder.addCase(
      thunks.getAiBuilderThunk.rejected,
      (state, { payload }) => {}
    );
    builder.addCase(
      thunks.getAiBuilderThunk.fulfilled,
      (state, { payload }) => {
        const data = payload?.originalData?.data;
        state.AIBuilderList = data || [];
        const meta = payload?.originalData?.meta;
        state.meta = meta || null;

        state.isLastPage =
          payload?.originalData?.links.next === null ||
          data.length < Number(meta?.per_page);
      }
    );
    builder.addCase(
      thunks.getAiBuilderDetailsThunk.pending,
      (state, { payload }) => {}
    );
    builder.addCase(
      thunks.getAiBuilderDetailsThunk.rejected,
      (state, { payload }) => {}
    );
    builder.addCase(
      thunks.getAiBuilderDetailsThunk.fulfilled,
      (state, { payload }) => {
        state.AIBuilderDetails = payload?.originalData || {};
      }
    );
  },
});

export const reducer = slice.reducer;
export const actions = { ...slice.actions, ...thunks };
